export const en = {
    'campaign-events': 'Events of this campaign',
    'change-traffic-value': 'Traffic volume change',
    'current-balance': 'Balance',
    'email-empty': 'Email address is not specified',
    'end-campaign': 'End of campaign',
    'increase-balance': 'Funds credited',
    'moderation-results': 'Moderation results',
    'monitoring-results': 'Website monitoring results',
    'percent-of-current-balance': 'Campaign balance level',
    'percent-of-current-balance-warning-empty': 'Balance level not set',
    'percent-of-current-balance-warning-interval': 'Balance level must be in the range from {min} to {max}',
    'stop-by-reach-daily-budget': 'Stopped when daily budget reached',
    'xls-ready': 'XLS reports ready'
};
